import { useAtom } from 'jotai';
import { TooltipStyled } from 'src/components/common';
import { useGetOrgUsers } from 'src/hooks';
import { orgTotalUsersAtom } from 'src/store';

export const CountAndLoadMore = () => {
  const [totalUsers] = useAtom(orgTotalUsersAtom);

  const usersQuery = useGetOrgUsers();
  const { hasNextPage, fetchNextPage, isFetchingNextPage } = usersQuery;

  const currentUsersDisplayed = usersQuery.data?.pages.reduce(
    (acc, page) => acc + page.users.length,
    0,
  );

  return (
    <div className='flex w-full flex-col items-center justify-start gap-x-3 gap-y-2 px-2 xs:px-3 sm:flex-row sm:px-4 md:px-8 lg:px-12'>
      <p className='text-200 text-balance text-center'>
        <strong>{currentUsersDisplayed ?? 0}</strong> of{' '}
        <strong>{totalUsers ?? 0}</strong> User{totalUsers === 1 ? '' : 's'}
      </p>
      <TooltipStyled
        title={'No more users to display'}
        placement='top'
        disableHoverListener={hasNextPage || isFetchingNextPage}
        disableTouchListener={hasNextPage || isFetchingNextPage}
      >
        <span onClick={() => fetchNextPage()}>
          <button
            className='button-secondary h-12 w-full max-w-fit'
            disabled={!hasNextPage || isFetchingNextPage}
          >
            Load More Users
          </button>
        </span>
      </TooltipStyled>
    </div>
  );
};
